import { render, staticRenderFns } from "./goal_edit.vue?vue&type=template&id=288542a4&scoped=true&"
import script from "./goal_edit.vue?vue&type=script&lang=js&"
export * from "./goal_edit.vue?vue&type=script&lang=js&"
import style0 from "./goal_edit.vue?vue&type=style&index=0&id=288542a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288542a4",
  null
  
)

export default component.exports